"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames = require("classnames");
var theme = require("../reportingList/theme.scss");
var ui_1 = require("@vidazoo/ui");
var utils_1 = require("@vidazoo/ui/lib/components/utils");
var utils_2 = require("../../../../utils");
var enums_1 = require("../../../../common/enums");
var lib_1 = require("../../../../../lib");
var components_1 = require("../../../reporting/components");
exports.default = React.memo(function (_a) {
    var field = _a.field, onQuickConstraint = _a.onQuickConstraint, setFreezeColumn = _a.setFreezeColumn, freezeColumnIndex = _a.freezeColumnIndex, dataGridColumnIndex = _a.dataGridColumnIndex, onSort = _a.onSort, sortDirection = _a.sortDirection;
    var _b;
    var displayValue = utils_2.extractReportingFieldValue(field, "displayValue", enums_1.ReportFieldValueType.ORIGINAL);
    var deltaPct, tooltip;
    if (field && field.value && field.value.length) {
        var deltaPctValue = parseInt(utils_2.extractReportingFieldValue(field, "value", enums_1.ReportFieldValueType.DELTA_PCT) * 100, 10), deltaValue = utils_2.extractReportingFieldValue(field, "displayValue", enums_1.ReportFieldValueType.DELTA), value = utils_2.extractReportingFieldValue(field, "displayValue", enums_1.ReportFieldValueType.ORIGINAL), compared = utils_2.extractReportingFieldValue(field, "displayValue", enums_1.ReportFieldValueType.COMPARE), sign = deltaPctValue > 0 ? "+" : "";
        deltaPct = React.createElement("span", { className: classnames(theme.trend, (_b = {},
                _b[theme.up] = deltaPctValue > 0,
                _b[theme.down] = deltaPctValue < 0,
                _b)) },
            "(",
            sign,
            deltaPctValue,
            "%)");
        tooltip = (React.createElement("div", { className: theme.popover },
            React.createElement("div", { className: theme.grid },
                React.createElement("div", { className: theme.item },
                    React.createElement(ui_1.Label, { weight: "bold", className: theme.title, size: 10, uppercase: true }, "Current"),
                    React.createElement("div", { className: theme.value }, value)),
                React.createElement("div", { className: theme.item },
                    React.createElement(ui_1.Label, { weight: "bold", className: theme.title, size: 10, uppercase: true }, "Compared To"),
                    React.createElement("div", { className: theme.value }, compared)),
                React.createElement("div", { className: theme.item },
                    React.createElement(ui_1.Label, { weight: "bold", className: theme.title, size: 10, uppercase: true }, "Change"),
                    React.createElement("div", { className: theme.value }, deltaValue)),
                React.createElement("div", { className: theme.item },
                    React.createElement(ui_1.Label, { weight: "bold", className: theme.title, size: 10, uppercase: true }, "Change (%)"),
                    React.createElement("div", { className: theme.value }, deltaPct)))));
    }
    var quickConstraint = function () {
        onQuickConstraint(field);
    };
    var onFreezeColumn = function () {
        setFreezeColumn({ target: { checked: freezeColumnIndex !== dataGridColumnIndex, value: dataGridColumnIndex } });
    };
    var onOrder = function () {
        onSort(field.name);
    };
    var onCopy = function () {
        lib_1.MemoryClipboard.copy(window.getSelection().toString() || field.value);
    };
    var cellToRender = onQuickConstraint
        ? React.createElement(components_1.QuickReportAction, { iconName: "icon-filter", tooltipTitle: "Add Constraint", item: field, onClick: onQuickConstraint },
            displayValue,
            " ",
            deltaPct)
        : displayValue + " " + (utils_1.isDefined(deltaPct) ? deltaPct : "");
    var valueRender = tooltip
        ? React.createElement(ui_1.Tooltip, { title: tooltip },
            React.createElement("span", null, cellToRender))
        : React.createElement("span", null, cellToRender);
    var contextMenuItems = [
        {
            label: freezeColumnIndex === dataGridColumnIndex ? "Unfreeze Column" : "Freeze Column",
            onClick: onFreezeColumn
        },
        { label: "Order " + sortDirection, onClick: onOrder },
        { label: "Copy", onClick: onCopy }
    ];
    if (onQuickConstraint) {
        contextMenuItems.push({ label: "Apply Constraint", onClick: quickConstraint });
    }
    return (React.createElement(ui_1.ContextMenu, { items: contextMenuItems },
        React.createElement("div", { className: theme.cell }, valueRender)));
});
